// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DayDetailBody_body__zmKzf {
  min-width: 0;
}

.DayDetailBody_loaderWrap__vyh2T {
  display: flex;
  justify-content: center;
  padding: 30px;
}

.DayDetailBody_errorMsg__ACMLn {
  color: #df6767;
  margin: 10px 0;
}

.DayDetailBody_meta__G7Ok- {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}
.DayDetailBody_meta__G7Ok- p {
  margin: 0;
}

.DayDetailBody_metaChips__1HBMQ {
  display: flex;
  align-items: center;
  gap: 5px;
}

.DayDetailBody_section__V5NND {
  margin-bottom: 20px;
}

.DayDetailBody_sectionTitle__M0QTo {
  font-size: 12px;
  font-weight: 600;
  margin: 0 0 5px;
  color: #838383;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.DayDetailBody_sectionCount__DooTA {
  margin-left: 5px;
  font-weight: 400;
  color: #acacac;
  text-transform: none;
  letter-spacing: 0;
}

.DayDetailBody_table__HlI9t {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}
.DayDetailBody_table__HlI9t th {
  text-align: left;
  padding: 4px 8px;
  border-bottom: 2px solid #dbdbdb;
  color: #838383;
  font-weight: 600;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.DayDetailBody_table__HlI9t td {
  padding: 4px 8px;
  border-bottom: 1px solid #f4f5f7;
  vertical-align: top;
}
.DayDetailBody_table__HlI9t tr:last-child td {
  border-bottom: none;
}

.DayDetailBody_mono__i0ehH {
  font-family: monospace;
  font-size: 11px;
  word-break: break-all;
}

.DayDetailBody_dim__paVu7 {
  color: #838383;
  font-size: 11px;
  white-space: nowrap;
}

.DayDetailBody_error__zCcs6 {
  color: #df6767;
  font-size: 11px;
}

.DayDetailBody_pairBadge__UoqeO {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.04em;
  white-space: nowrap;
  text-transform: uppercase;
}

.DayDetailBody_pairBadgePrimary__UiJOi {
  background: rgba(87, 188, 143, 0.18);
  color: #2d8758;
  border: 1px solid rgba(87, 188, 143, 0.4);
}

.DayDetailBody_pairBadgeDup__JBaHd {
  background: rgba(142, 106, 203, 0.18);
  color: #6244a0;
  border: 1px solid rgba(142, 106, 203, 0.4);
}

.DayDetailBody_pairDup__xhtDu td {
  background: rgba(142, 106, 203, 0.05);
}

.DayDetailBody_chip__qtnxS {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 600;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.DayDetailBody_chip_processed__IlfV9 {
  background: var(--accent-color);
}

.DayDetailBody_chip_processing__iS0RP {
  background: #3b7fd4;
}

.DayDetailBody_chip_pending__AdTCk {
  background: #00bcd4;
}

.DayDetailBody_chip_waiting_archive__rpVff {
  background: #64b5f6;
}

.DayDetailBody_chip_duplicate__0vHrd {
  background: #8e6acb;
}

.DayDetailBody_chip_upload_failed__pytcT {
  background: #efa12c;
}

.DayDetailBody_chip_failed__9bpRd {
  background: #df6767;
}

.DayDetailBody_chip_no_data__m0cCp {
  background: #7a7a7a;
}

.DayDetailBody_chip_reingested__olq-N {
  background: #5c6bc0;
}

.DayDetailBody_chip_bad_content__ohLd2 {
  background: #df6767;
}

.DayDetailBody_chip_waiting_pair__6DDVc {
  background: #00bcd4;
}

.DayDetailBody_chip_sent__Il\\+cL {
  background: var(--accent-color);
}

.DayDetailBody_notes__dQ62g {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-bottom: 20px;
}

.DayDetailBody_note__4mz3m {
  padding: 2px 10px;
  border-radius: 4px;
  font-size: 12px;
  background: rgba(142, 106, 203, 0.12);
}

.DayDetailBody_liveBtn__rVPdv {
  padding: 1px 8px;
  font-size: 11px;
  border: 1px solid rgba(142, 106, 203, 0.5);
  border-radius: 3px;
  background: transparent;
  cursor: pointer;
}
.DayDetailBody_liveBtn__rVPdv:disabled {
  opacity: 0.5;
  cursor: default;
}

.DayDetailBody_noteWarn__1kNsb {
  background: rgba(239, 161, 44, 0.2);
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/dashboard/components/SyncMonitor/DayDetailBody/DayDetailBody.module.scss","webpack://./src/_common/scss/_variables.scss","webpack://./src/_common/scss/_colors.scss"],"names":[],"mappings":"AAGA;EACE,YAAA;AAFF;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,aCHW;ADCb;;AAKA;EACE,cEDM;EFEN,cAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,SCXS;EDYT,mBCXS;EDYT,eAAA;AAFF;AAIE;EAAI,SAAA;AADN;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QCtBS;ADqBX;;AAIA;EACE,mBCxBS;ADuBX;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,cEjCS;EFkCT,yBAAA;EACA,sBAAA;AADF;;AAIA;EACE,gBCvCS;EDwCT,gBAAA;EACA,cE1CS;EF2CT,oBAAA;EACA,iBAAA;AADF;;AAIA;EACE,WAAA;EACA,yBAAA;EACA,eAAA;AADF;AAGE;EACE,gBAAA;EACA,gBAAA;EACA,gCAAA;EACA,cEvDO;EFwDP,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;AADJ;AAIE;EACE,gBAAA;EACA,gCAAA;EACA,mBAAA;AAFJ;AAKE;EAAmB,mBAAA;AAFrB;;AAKA;EACE,sBAAA;EACA,eAAA;EACA,qBAAA;AAFF;;AAKA;EACE,cE9ES;EF+ET,eAAA;EACA,mBAAA;AAFF;;AAKA;EACE,cEhFM;EFiFN,eAAA;AAFF;;AAKA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;AAFF;;AAKA;EACE,oCAAA;EACA,cAAA;EACA,yCAAA;AAFF;;AAKA;EACE,qCAAA;EACA,cAAA;EACA,0CAAA;AAFF;;AAKA;EACE,qCAAA;AAFF;;AAOA;EACE,qBAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,WEtHM;EFuHN,yBAAA;EACA,sBAAA;AAJF;;AAOA;EAAyB,+BEvIhB;AFoIT;;AAIA;EAAyB,mBAAA;AAAzB;;AACA;EAAyB,mBAAA;AAGzB;;AAFA;EAAyB,mBAAA;AAMzB;;AALA;EAAyB,mBAAA;AASzB;;AARA;EAAyB,mBAAA;AAYzB;;AAXA;EAAyB,mBElIjB;AFiJR;;AAdA;EAAyB,mBAAA;AAkBzB;;AAjBA;EAA4B,mBAAA;AAqB5B;;AApBA;EAA4B,mBErIpB;AF6JR;;AAvBA;EAA4B,mBAAA;AA2B5B;;AA1BA;EAA4B,+BElJnB;AFgLT;;AA1BA;EACE,aAAA;EACA,eAAA;EACA,QClJS;EDmJT,mBCjJS;AD8KX;;AA1BA;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,qCAAA;AA6BF;;AA1BA;EACE,gBAAA;EACA,eAAA;EACA,0CAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;AA6BF;AA3BE;EACE,YAAA;EACA,eAAA;AA6BJ;;AAzBA;EACE,mCAAA;EACA,gBAAA;AA4BF","sourcesContent":["@import '@common/scss/_variables';\n@import '@common/scss/_colors';\n\n.body {\n  min-width: 0;\n}\n\n.loaderWrap {\n  display: flex;\n  justify-content: center;\n  padding: $padding-xl;\n}\n\n.errorMsg {\n  color: $error;\n  margin: $margin-m 0;\n}\n\n.meta {\n  display: flex;\n  align-items: center;\n  gap: $margin-m;\n  margin-bottom: $margin-l;\n  flex-wrap: wrap;\n\n  p { margin: 0; }\n}\n\n.metaChips {\n  display: flex;\n  align-items: center;\n  gap: $margin-s;\n}\n\n.section {\n  margin-bottom: $margin-l;\n}\n\n.sectionTitle {\n  font-size: 12px;\n  font-weight: 600;\n  margin: 0 0 $margin-s;\n  color: $grey-400;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.sectionCount {\n  margin-left: $margin-s;\n  font-weight: 400;\n  color: $grey-300;\n  text-transform: none;\n  letter-spacing: 0;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n\n  th {\n    text-align: left;\n    padding: 4px 8px;\n    border-bottom: 2px solid $grey-200;\n    color: $grey-400;\n    font-weight: 600;\n    font-size: 11px;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n  }\n\n  td {\n    padding: 4px 8px;\n    border-bottom: 1px solid $grey-100;\n    vertical-align: top;\n  }\n\n  tr:last-child td { border-bottom: none; }\n}\n\n.mono {\n  font-family: monospace;\n  font-size: 11px;\n  word-break: break-all;\n}\n\n.dim {\n  color: $grey-400;\n  font-size: 11px;\n  white-space: nowrap;\n}\n\n.error {\n  color: $error;\n  font-size: 11px;\n}\n\n.pairBadge {\n  display: inline-block;\n  padding: 2px 6px;\n  border-radius: 3px;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  white-space: nowrap;\n  text-transform: uppercase;\n}\n\n.pairBadgePrimary {\n  background: rgba(87, 188, 143, 0.18);\n  color: #2d8758;\n  border: 1px solid rgba(87, 188, 143, 0.4);\n}\n\n.pairBadgeDup {\n  background: rgba(142, 106, 203, 0.18);\n  color: #6244a0;\n  border: 1px solid rgba(142, 106, 203, 0.4);\n}\n\n.pairDup td {\n  background: rgba(142, 106, 203, 0.05);\n}\n\n// ─── Status chip ─────────────────────────────────────────────────────────────\n\n.chip {\n  display: inline-block;\n  padding: 1px 8px;\n  border-radius: 999px;\n  font-size: 10px;\n  font-weight: 600;\n  color: $white;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.chip_processed        { background: $accent; }\n.chip_processing       { background: #3b7fd4; }\n.chip_pending          { background: #00bcd4; }\n.chip_waiting_archive  { background: #64b5f6; }\n.chip_duplicate        { background: #8e6acb; }\n.chip_upload_failed    { background: #efa12c; }\n.chip_failed           { background: $error; }\n.chip_no_data          { background: #7a7a7a; }\n.chip_reingested          { background: #5c6bc0; }\n.chip_bad_content         { background: $error; }\n.chip_waiting_pair        { background: #00bcd4; }\n.chip_sent                { background: $accent; }\n\n// ─── Delivery notes ──────────────────────────────────────────────────────────\n\n.notes {\n  display: flex;\n  flex-wrap: wrap;\n  gap: $margin-s;\n  margin-bottom: $margin-l;\n}\n\n.note {\n  padding: 2px 10px;\n  border-radius: 4px;\n  font-size: 12px;\n  background: rgba(142, 106, 203, 0.12);\n}\n\n.liveBtn {\n  padding: 1px 8px;\n  font-size: 11px;\n  border: 1px solid rgba(142, 106, 203, 0.5);\n  border-radius: 3px;\n  background: transparent;\n  cursor: pointer;\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: default;\n  }\n}\n\n.noteWarn {\n  background: rgba(239, 161, 44, 0.2);\n  font-weight: 600;\n}\n","@import './colors';\n\n$border-radius: 3px !default;\n$border-radius-extra: 8px !default;\n$padding-s: 5px;\n$padding-m: 10px;\n$padding-l: 20px;\n$padding-xl: 30px;\n$padding-xxl: 40px;\n$margin-s: 5px;\n$margin-m: 10px;\n$margin-l: 20px;\n$margin-xl: 30px;\n$margin-xxl: 40px;\n$margin-xxxl: 50px;\n$shadow-depth: 1;\n$base-font-size: 14px !default;\n$base-line-height: 17px !default;\n$base-unit: 'em' !default;\n$base-font-family: 'Source Sans Pro', sans-serif !default;\n$h1-font-size: 2 * $base-font-size !default;\n$h2-font-size: 1.5 * $base-font-size !default;\n$h3-font-size: 1.17 * $base-font-size !default;\n$h4-font-size: 1 * $base-font-size !default;\n$h5-font-size: 0.83 * $base-font-size !default;\n$h6-font-size: 0.67 * $base-font-size !default;\n$indent-amount: 40px !default;\n$normalize-vertical-rhythm: false !default;\n$default-border: solid 1px $default-border-color;\n$navbar-z-index: 10000;\n$top-most-z-index: 100000;\n$navbar-height: 67px;\n$navbar-bg: #d9d9d9;\n$default-navbar-shadow: 0 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-statscard-shadow: 3px 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-mainfilters-shadow: inset -3px 0 3px rgb(0 0 0 / 0.1);\n","$primary: var(--primary-color);\n$secondary: var(--secondary-color);\n$accent: var(--accent-color);\n$font-primary: var(--font-primary-color);\n$font-secondary: var(--font-secondary-color);\n$font-accent: var(--font-accent-color);\n$grey-100: #f4f5f7;\n$grey-200: #dbdbdb;\n$grey-300: #acacac;\n$grey-400: #838383;\n$chart-dataset-1: #df6767;\n$chart-dataset-2: #efa12c;\n$warning: orange;\n$error: #df6767;\n$white: #fff;\n$transparent: transparent;\n\n$primary-font-color: #fff;\n$secondary-font-color: #fff;\n$accent-font-color: #fff;\n$warning-font-color: #fff;\n$error-font-color: #fff;\n$filter-bg: #fff;\n\n$bg-main: var(--background-color);\n$card-bg: #fff;\n$default-control-bg: #fff;\n$card-shadow: 3px 3px 3px -1px rgba(0, 0, 0, 0.1);\n$default-shadow-color: rgba(0, 0, 0, 0.1);\n\n$default-border-color: #acacac;\n$default-backdrop-color: rgba(0, 0, 0, 0.8);\n\n$default-navbar-color: #fff;\n\n$stats-card-bg-color: #fff;\n$stats-card-color: #000;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `DayDetailBody_body__zmKzf`,
	"loaderWrap": `DayDetailBody_loaderWrap__vyh2T`,
	"errorMsg": `DayDetailBody_errorMsg__ACMLn`,
	"meta": `DayDetailBody_meta__G7Ok-`,
	"metaChips": `DayDetailBody_metaChips__1HBMQ`,
	"section": `DayDetailBody_section__V5NND`,
	"sectionTitle": `DayDetailBody_sectionTitle__M0QTo`,
	"sectionCount": `DayDetailBody_sectionCount__DooTA`,
	"table": `DayDetailBody_table__HlI9t`,
	"mono": `DayDetailBody_mono__i0ehH`,
	"dim": `DayDetailBody_dim__paVu7`,
	"error": `DayDetailBody_error__zCcs6`,
	"pairBadge": `DayDetailBody_pairBadge__UoqeO`,
	"pairBadgePrimary": `DayDetailBody_pairBadgePrimary__UiJOi`,
	"pairBadgeDup": `DayDetailBody_pairBadgeDup__JBaHd`,
	"pairDup": `DayDetailBody_pairDup__xhtDu`,
	"chip": `DayDetailBody_chip__qtnxS`,
	"chip_processed": `DayDetailBody_chip_processed__IlfV9`,
	"chip_processing": `DayDetailBody_chip_processing__iS0RP`,
	"chip_pending": `DayDetailBody_chip_pending__AdTCk`,
	"chip_waiting_archive": `DayDetailBody_chip_waiting_archive__rpVff`,
	"chip_duplicate": `DayDetailBody_chip_duplicate__0vHrd`,
	"chip_upload_failed": `DayDetailBody_chip_upload_failed__pytcT`,
	"chip_failed": `DayDetailBody_chip_failed__9bpRd`,
	"chip_no_data": `DayDetailBody_chip_no_data__m0cCp`,
	"chip_reingested": `DayDetailBody_chip_reingested__olq-N`,
	"chip_bad_content": `DayDetailBody_chip_bad_content__ohLd2`,
	"chip_waiting_pair": `DayDetailBody_chip_waiting_pair__6DDVc`,
	"chip_sent": `DayDetailBody_chip_sent__Il+cL`,
	"notes": `DayDetailBody_notes__dQ62g`,
	"note": `DayDetailBody_note__4mz3m`,
	"liveBtn": `DayDetailBody_liveBtn__rVPdv`,
	"noteWarn": `DayDetailBody_noteWarn__1kNsb`
};
export default ___CSS_LOADER_EXPORT___;
